import React from "react";
import Calculator from "../Calculator";

const Contact = (props) => {
  return <Calculator language={props.language} />;
};

export default Contact;
